const utils = {};

/**
 * 計算住院醫囑花費金額
 */
utils.calInHospitalPlanTotalVer2 = (plan = {}) => {
  let total = 0;
  if (plan.cage && plan.cage.subTotal) {
    //籠位費
    total += parseInt(plan.cage.subTotal || 0);
  }
  if (plan.drugSubTotal) {
    //口服藥
    total += parseInt(plan.drugSubTotal || 0);
  }

  if (plan.infusionDrugSubTotal) {
    //輸液
    total += parseInt(plan.infusionDrugSubTotal || 0);
  }

  //針劑費用
  if (plan.injectionMission) {
    plan.injectionMission.forEach((mission) => {
      total += parseInt(mission.subTotal || 0);
    });
  }

  //其他處置費用(舊版)
  if (plan.threrapyMission) {
    plan.threrapyMission.forEach((mission) => {
      total += parseInt(mission.subTotal || 0);
    });
  }
  //其他處置費用
  if (plan.otherTherapyMission) {
    plan.otherTherapyMission.forEach((mission) => {
      total += parseInt(mission.subTotal || 0);
    });
  }
  //檢驗處置費用
  if (plan.examTherapyMission) {
    plan.examTherapyMission.forEach((mission) => {
      total += parseInt(mission.subTotal || 0);
    });
  }

  //收費服務費用
  if (plan.chargeService) {
    plan.chargeService.forEach((charge) => {
      total += parseInt(charge.subTotal || 0);
    });
  }

  //收費商品耗材費用
  if (plan.chargeProduct) {
    plan.chargeProduct.forEach((charge) => {
      total += parseInt(charge.subTotal || 0);
    });
  }
  return total;
};
export default utils;
